<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_MS = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Timer und Anfragezähler je Komponenteninstanz
    this.debounceTimer = null;
    this.requestId = 0;
    this.destroyed = false;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.cancelPending();
  },

  watch: {
    search(val) {
      if (!val || !val.trim()) {
        this.cancelPending();
        this.items = this.select ? [this.select] : [];
        return;
      }

      // Der gewählte Wert kommt als Objekt (Auswahl) oder als Text (v-model
      // des Elternteils) zurück; dessen Anzeigetext löst keine Suche aus.
      const selectedText = this.select && typeof this.select === "object"
        ? this.select.text
        : this.select;
      if (val === selectedText) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage und macht verspätete Antworten ungültig.
    cancelPending() {
      this.requestId++;
      if (this.debounceTimer != null) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
      this.loading = false;
    },

    querySelections(value) {
      this.cancelPending();
      const id = this.requestId;
      this.loading = true;

      this.debounceTimer = setTimeout(() => {
        this.debounceTimer = null;

        this.geocoderReady.then(geocoder => {
          if (id !== this.requestId || this.destroyed) {
            return null;
          }
          return geocoder.autocomplete(value);
        }).then(items => {
          if (id !== this.requestId || this.destroyed || items === null) {
            return;
          }
          this.items = items.slice();
        }).catch(err => {
          if (id === this.requestId && !this.destroyed) {
            console.log(err);
            this.items = [];
          }
        }).finally(() => {
          if (id === this.requestId && !this.destroyed) {
            this.loading = false;
          }
        });
      }, DEBOUNCE_MS);
    },

    change(o) {
      this.cancelPending();
      this.items = o ? [o] : [];
      this.$emit("change", o);
    }
  }
};
</script>
